export const defaultES = {
  404: {
    main: '¡Oops! La página solicitada no fue encontrada.',
    back: 'Volver al Inicio'
  }
}
